const IntegrationStatusEnum = Object.freeze({
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED'
});

export default IntegrationStatusEnum;
